import { ReactNode } from "react";
import { CommonContentMessage } from "../../types";
import { EventBody, MessageComponent, MessageComponentProps } from "./Message";
import { HighlightedText } from "../../agent/stateComponents/SimpleComponentVisualization";

const ContentMessage: MessageComponent<CommonContentMessage> = ({
  message,
  textFilter,
}: MessageComponentProps<CommonContentMessage>) => {
  let content: ReactNode = (
    <HighlightedText
      text={(message.content as string) ?? ""}
      textFilter={textFilter}
    />
  );

  if (
    message.sender === "generate_text" ||
    message.sender === "generate_json"
  ) {
    content = <span style={{ color: "var(--bs-code-color)" }}>{content}</span>;
  }
  return <EventBody>{content}</EventBody>;
};

export default ContentMessage;
